import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/widthdrawall.css';

function Widthdrawall() {
  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);

  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(`${baseUrl}/users`);
        if (!response.ok) throw new Error('Failed to fetch data');
        const data = await response.json();
        setUsers(data);
        const initialSelected = data.filter(u => u.status === 0).map(u => u.id);
        setSelectedUsers(initialSelected);
        setIsLoading(false);
      } catch (err) {
        setError(err.message);
        setIsLoading(false);
      }
    };
    fetchUsers();
  }, []);

  const filteredUsers = users.filter(u =>
    u.username.toLowerCase().includes(searchQuery.toLowerCase()) ||
    u.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
    u.role.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleCheckboxChange = (userId) => {
    setSelectedUsers(prev =>
      prev.includes(userId)
        ? prev.filter(id => id !== userId)
        : [...prev, userId]
    );
  };

  const handleSelectAll = () => {
    if (selectedUsers.length === filteredUsers.length) {
      setSelectedUsers([]);
    } else {
      setSelectedUsers(filteredUsers.map(u => u.id));
    }
  };

  const handleUpdateStatus = async () => {
    try {
      await Promise.all(
        filteredUsers.map(async (user) => {
          const newStatus = selectedUsers.includes(user.id) ? 0 : 1;
          const res = await fetch(`${baseUrl}/users/${user.id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ status: newStatus }),
          });
          if (!res.ok) throw new Error(`Failed to update ${user.username}`);
        })
      );
      toast.success('Status updated successfully!');
      setTimeout(() => window.location.reload(), 1500);
    } catch (err) {
      toast.error('Failed to update status');
    }
  };

  if (isLoading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="List-price">
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Search + Update Button */}
      <div className="search-update-row">
        <div className="search-column">
          <input
            type="text"
            placeholder="Search by Username, Email, or Role..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input"
          />
        </div>
        <div className="button-column">
          <button
            className="update-button"
            onClick={handleUpdateStatus}
            disabled={filteredUsers.length === 0}
          >
            Update Status
          </button>
        </div>
      </div>

      {/* User Blocks */}
      <div className="table-container">
         {/* Select All Checkbox (Sticky at Bottom) */}
        {filteredUsers.length > 0 && (
          <div style={{
            textAlign: 'center',
            padding: '16px',
            background: '#f8f9fa',
            borderRadius: '10px',
            marginTop: '10px',
            border: '1px solid #e2e8f0'
          }}>
            <label style={{ fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
              <input
                type="checkbox"
                checked={filteredUsers.length > 0 && filteredUsers.every(u => selectedUsers.includes(u.id))}
                onChange={handleSelectAll}
                style={{ width: '18px', height: '18px' }}
              />
              Select All Visible Users
            </label>
          </div>
        )}
        {filteredUsers.map((user, index) => (
          <div key={user.id} className="user-block">
            <table className="data-table">
              <tbody>
                <tr>
                  <td>No:</td>
                  <td>{index + 1}</td>
                </tr>
                <tr>
                  <td>Username:</td>
                  <td>{user.username}</td>
                </tr>
                <tr>
                  <td>Email:</td>
                  <td>{user.email}</td>
                </tr>
                <tr>
                  <td>Role:</td>
                  <td>{user.role}</td>
                </tr>
                <tr>
                  <td>Status:</td>
                  <td className={user.status === 0 ? 'status-win' : 'status-loss'}>
                    {user.status === 0 ? 'Win' : 'Loss'}
                  </td>
                </tr>
                <tr>
                  <td>Select:</td>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedUsers.includes(user.id)}
                      onChange={() => handleCheckboxChange(user.id)}
                    />
                    <span style={{ marginLeft: 8, fontSize: '14px', color: '#666' }}>
                      Mark as Win
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ))}

       
      </div>
    </div>
  );
}

export default Widthdrawall;